// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { InternalDocumentTypeIds } from '@interfaces/document.interfaces';
import { isDriversLicense } from 'src/app/utils/document-utils';

@Component({
    selector: 'app-mobile-only-upload-modal',
    templateUrl: './mobile-only-upload-modal.component.html',
    styleUrls: ['./mobile-only-upload-modal.component.scss'],
})
export class MobileOnlyUploadModalComponent {
    public idType: 'license' | 'extendedId';
    constructor(
        private dialogRef: MatDialogRef<MobileOnlyUploadModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { internalDocumentTypeId: InternalDocumentTypeIds }
    ) {
        if (isDriversLicense(data.internalDocumentTypeId)) {
            this.idType = 'license';
        } else {
            this.idType = 'extendedId';
        }
    }

    ok() {
        this.dialogRef.close();
    }
}
